<template>
  <div class="card card-custom gutter-b form">
    <div class="card-body">
      <v-tabs v-model="tab" background-color="white" grow>
        <v-tab>Overall</v-tab>
        <v-tab>Ratings Received by Clients</v-tab>
        <v-tab disabled>Ratings Given</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <TalentRatingsSummaryTab :talentId="talentId" />
        </v-tab-item>
        <v-tab-item>
          <RatingsReceivedByColleaguesTab :talentId="talentId" />
        </v-tab-item>
        <v-tab-item>
          <RatingsGivenTab :talentId="talentId" />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import TalentRatingsSummaryTab from "./TalentRatingsSummaryTab.vue";
import RatingsReceivedByColleaguesTab from "./RatingsReceivedByColleaguesTab.vue";
import RatingsGivenTab from "./RatingsGivenTab.vue";

export default {
  name: "TalentRatingsTabs",
  props: {
    talentId: {
      type: [String, Number],
      required: true,
    },
  },
  components: {
    TalentRatingsSummaryTab,
    RatingsReceivedByColleaguesTab,
    RatingsGivenTab,
  },
  data() {
    return {
      tab: 0,
    };
  },
};
</script>
